import React, { useState } from 'react';
import {
  Container,
  TextField,
  Button,
  Typography,
  Paper,
  Box,
  Grid
} from '@mui/material';
import { ArrowBack as ArrowBackIcon, Save as SaveIcon, Campaign as CampaignIcon } from '@mui/icons-material';
import { registrarTipoCampana } from '../../../actions/CampanasAction';
import { useStateValue } from '../../../contexto/store';
import { RegistrarAccion } from '../../../actions/AuditoriaAction';

const NuevoTipoCampana = (props) => {
  //eslint-disable-next-line
  const [{ openSnackar, sesionUsuario }, dispatch] = useStateValue();

  const [tipoCampana, setTipoCampana] = useState({
    id: '',
    CODTIPOCAMPANA: 0,
    DESCRITIPOCAMPANA: '',
  });

  const ingresarValoresMemoria = (e) => {
    const { name, value } = e.target;
    setTipoCampana((anterior) => ({
      ...anterior,
      [name]: value,
    }));
  };

  //RRR: FUNCION PARA GUARDAR NUEVO TIPO DE CAMPAÑA
  const guardarTipoCampana = (e) => {
    e.preventDefault();
    const objetotipoCampana = {
      CODTIPOCAMPANA: parseInt(tipoCampana.CODTIPOCAMPANA),
      DESCRITIPOCAMPANA: tipoCampana.DESCRITIPOCAMPANA,
    };
    registrarTipoCampana(objetotipoCampana).then((response) => {
      if (response.status === 200) {
        dispatch({
          type: 'OPEN_SNACKBAR',
          openMensaje: {
            open: true,
            mensaje: 'Se guardo exitosamente el Tipo de Campana',
          },
        });
        setTipoCampana({
          id: '',
          CODTIPOCAMPANA: 0,
          DESCRITIPOCAMPANA: '',
        });
        let objetoAudi = {
          usuario: sesionUsuario.usuario.nombrecompleto,
          accion: 'Registro',
          panel: 'Seguridad',
          tabla: 'TIPOCAMPAÑA',
          filaafectada: 'NUEVO REGISTRO',
          UsuarioId: sesionUsuario.usuario.id,
        };
        RegistrarAccion(objetoAudi);
      } else {
        dispatch({
          type: 'OPEN_SNACKBAR',
          openMensaje: {
            open: true,
            mensaje: 'Errores al intentar guardar ',
          },
        });
      }
    });
  };

  const volverTabla = (e) => {
    props.history.push('/tiposcampanas');
  };

  return (
    <Container maxWidth="lg" sx={{ py: 4 }}>
      {/* Header con gradiente */}
      <Paper
        elevation={0}
        sx={{
          p: 3,
          mb: 4,
          background: 'linear-gradient(135deg, #1976d2 0%, #0d47a1 100%)',
          borderRadius: 2,
        }}
      >
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
          <Box
            sx={{
              width: 56,
              height: 56,
              borderRadius: 2,
              background: 'rgba(255,255,255,0.2)',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              backdropFilter: 'blur(10px)',
            }}
          >
            <CampaignIcon sx={{ fontSize: 32, color: 'white' }} />
          </Box>
          <Box>
            <Typography variant="h4" sx={{ color: 'white', fontWeight: 600 }}>
              Nuevo Tipo de Campaña
            </Typography>
            <Typography variant="body2" sx={{ color: 'rgba(255,255,255,0.9)' }}>
              Registra un nuevo tipo de campaña en el sistema
            </Typography>
          </Box>
        </Box>
      </Paper>

      {/* Información del Tipo de Campaña */}
      <Paper
        elevation={0}
        sx={{
          p: 4,
          mb: 3,
          borderRadius: 2,
          border: '1px solid',
          borderColor: 'divider',
        }}
      >
        <Typography variant="h6" sx={{ mb: 3, fontWeight: 600 }}>
          Información del Tipo de Campaña
        </Typography>
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <TextField
              name="DESCRITIPOCAMPANA"
              value={tipoCampana.DESCRITIPOCAMPANA}
              fullWidth
              onChange={ingresarValoresMemoria}
              variant="outlined"
              label="Descripción *"
              placeholder="Ingrese la descripción del tipo de campaña"
              required
            />
          </Grid>
        </Grid>
      </Paper>

      {/* Botones de acción */}
      <Box
        sx={{
          display: 'flex',
          gap: 2,
          flexDirection: { xs: 'column', sm: 'row' },
          justifyContent: 'center',
        }}
      >
        <Button
          variant="outlined"
          size="large"
          startIcon={<ArrowBackIcon />}
          onClick={volverTabla}
          sx={{
            textTransform: 'none',
            fontWeight: 600,
            px: 4,
            py: 1.5,
            borderRadius: 2,
            borderWidth: 2,
            '&:hover': {
              borderWidth: 2,
              transform: 'translateY(-2px)',
              boxShadow: 2,
            },
            transition: 'all 0.2s ease',
          }}
        >
          Volver
        </Button>

        <Button
          variant="contained"
          size="large"
          startIcon={<SaveIcon />}
          onClick={guardarTipoCampana}
          sx={{
            textTransform: 'none',
            fontWeight: 600,
            px: 4,
            py: 1.5,
            borderRadius: 2,
            boxShadow: 2,
            '&:hover': {
              boxShadow: 4,
              transform: 'translateY(-2px)',
            },
            transition: 'all 0.2s ease',
          }}
        >
          Guardar Tipo de Campaña
        </Button>
      </Box>
    </Container>
  );
};

export default NuevoTipoCampana;
